import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";

export interface SubscriptionAlertsData {
    categoryIds: number[];
}

export class SubscriptionAlerts implements FormValidationModel<SubscriptionAlertsData> {
    public data: SubscriptionAlertsData;
    public rules: yup.Schema<SubscriptionAlertsData>;

    public constructor() {
        this.data = {
            categoryIds: [],
        };
        this.rules = yup.object<SubscriptionAlertsData>().shape({
            categoryIds: yup.array().of(yup.number()).label("Categories"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/careerCenter/SubscriptionAlerts.ts